var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaybackSettingsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M20 2q.824 0 1.413.587Q22 3.176 22 4v8.605A7 7 0 0 0 12.824 22L4.001 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 20V4q0-.824.587-1.412A1.93 1.93 0 0 1 4 2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  fillRule: "evenodd",
  d: "m20 4 .001 8.051a7 7 0 0 0-7.78 7.95L4 20V4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "nonzero",
  d: "m18.15 24-.3-1.5q-.3-.124-.562-.262a4.4 4.4 0 0 1-.538-.338l-1.45.45-1-1.7 1.15-1a5 5 0 0 1-.05-.65q0-.3.05-.65l-1.15-1 1-1.7 1.45.45q.275-.2.538-.338.261-.137.562-.262l.3-1.5h2l.3 1.5q.3.125.563.275t.537.375l1.45-.5 1 1.75-1.15 1q.05.3.05.625t-.05.625l1.15 1-1 1.7-1.45-.45a4.4 4.4 0 0 1-.538.338q-.262.137-.562.262l-.3 1.5zm1-3q.824 0 1.413-.587.587-.588.587-1.413 0-.824-.587-1.413A1.93 1.93 0 0 0 19.15 17q-.825 0-1.412.587A1.93 1.93 0 0 0 17.15 19q0 .824.588 1.413.587.587 1.412.587"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#006C8E",
  fillRule: "evenodd",
  points: "9.5 16.5 16.5 12 9.5 7.5"
}))));
export default SvgPlaybackSettingsIcon;